import { render, staticRenderFns } from "./TranscriptionSignals.vue?vue&type=template&id=425d4328"
import script from "./TranscriptionSignals.vue?vue&type=script&lang=js"
export * from "./TranscriptionSignals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports